module.exports = __webpack_public_path__ + "static/media/ic_head2.d2903ace.png";